<template>
  <el-dialog
    z-index="1000"
    @click.native.stop
    :visible="true"
    @close="onClose"
    :title="title+'分组'"
    width="766px"
    custom-class="theme-dialog split-line-footer-dialog dialog-body-0 answer-group-popup"
  >
    <div class="clearfix mt-6" style="height: 500px" ref="container">
      <div class="float-left w-1/2 h-full border-r border-border-gray border-solid box-border">
        <div class="h-full flex flex-col">
          <div class="px-4 mb-4 text-theme-black-850">
            <span class="leading-base font-medium">待分组{{title}}</span>
          </div>
          <div class="flex-1 overflow-y-auto">
            <div class="px-4 mb-4">
              <el-input placeholder="搜索" v-model="inputValue" suffix-icon="el-icon-search" />
            </div>

            <ul ref="leftItemContainer">
              <li v-for="item in noGroupItems" :key="item.id" class="pr-6">
                <div class="px-4 py-1 hover:bg-theme-gray relative box-border" data-drag="1" :data-type="item.id">
                  <div class="leading-22 answer-group-rich-text break-all" v-html="item.content.richText"></div>
                  <div class="absolute inset-0"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="float-left w-1/2 h-full">
        <div class="h-full flex flex-col">
          <div class="px-4 mb-4 text-theme-black-850 flex justify-between items-center">
            <span class="leading-base font-medium">分组管理</span>
            <el-button type="text" icon="icon-tianjia" @click="onAddGroup">
              <span class="ml-1">添加分组</span>
            </el-button>
          </div>
          <div class="px-4 flex-1 overflow-y-auto relative">
            <ul class="h-full overflow-y-auto" ref="rightContainer">
              <li v-for="(g, index) in groupList" :key="index" :class="['mb-4 last:mb-0',title == '地区' ? 'mr-1' : '']">
                <div class="flex items-center">
                  <div class="relative pr-10 w-full leading-normal" v-if="!g.isEdit">
                    <span>{{ g.title }}</span>
                    <div class="absolute-right text-theme">
                      <span class="mr-2 cursor-pointer" @click="editTitle(g, index)">
                        <i class="icon-bianji text-theme-black-450"></i>
                      </span>
                      <span class="cursor-pointer" @click="onRemoveGroup(g, index)">
                        <i class="icon-shanchu1 text-theme-black-450"></i>
                      </span>
                    </div>
                  </div>
                  <template v-else>
                    <rich-text-input
                      :data-idx="index"
                      ref="richInput"
                      class="w-full"
                      v-model="g.title"
                      @blur="g.isEdit = false"
                    />
                  </template>
                </div>
                <ul class="answer-group-box overflow-y-auto mt-2 drag-class-box" data-group="1" :data-id="index">
                  <template v-if="!g.items.length">
                    <div class="text-center h-full w-full flex">
                      <span class="m-auto text-black text-opacity-25">将左边的选项拖拽到此区域</span>
                    </div>
                  </template>
                  <template v-else>
                    <li v-for="(i, idx) in g.items" :key="i.id" class="relative pr-10 leading-base py-1 px-5 leading-22">
                      <div class="answer-group-rich-text" v-html="i.content.richText"></div>
                      <span
                        class="cursor-pointer absolute right-0 top-0 mr-3 text-icon-default py-1"
                        @click="onRemove(g, i, idx)"
                      >
                        <i class="icon-jc-close text-theme-black-450"></i>
                      </span>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="text-right">
        <!-- <el-button size="small" class="normal-button" @click="onClose">取消</el-button> -->
        <el-button size="small" type="primary" class="normal-button" @click="onConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { getTextByContent } from '@/question/util'
import { drag } from '@/assets/js/drag'
import RichTextInput from '@/components/base/RichTextInput'
import { CHANGE_WINDOW_CLICK_SELECT_QUESTION } from '@/assets/js/config/bus'

export default {
  name: 'AnswerGroup',
  components: { RichTextInput },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '选项'
    },
    notNeedClose: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      checkList: [],
      itemList: [],
      groupList: [],
      inputValue: ''
    }
  },
  computed: {
    noGroupItems() {
      let val = this.inputValue

      return this.itemList.filter(item => !item.flag && item.content.text.includes(val))
    }
  },
  created() {
    this.init()
  },
  methods: {
    onAddGroup() {
      let text = getTextByContent(
        this.groupList.map(g => {
          return {
            content: {
              text: g.title
            }
          }
        }),
        '分组'
      )
      this.groupList.push({
        title: text,
        isEdit: false,
        items: []
      })
    },
    onJoin(group) {
      const checkList = this.checkList
      const noGroupItems = this.noGroupItems
      const appendItems = noGroupItems.filter(i => checkList.includes(i.id))
      appendItems.forEach(item => {
        item.flag = true
        group?.items?.push(item)
        group?.item_ids?.push(item.id)
      })
      this.inputValue = ''
      this.checkList = []
    },
    editTitle(g, index) {
      g.isEdit = true
      this.$nextTick(() => {
        let vm = this.$refs.richInput[0]
        vm.focus()
        vm.selectAll()
      })
    },
    onRemove(group, item, index) {
      group.items.splice(index, 1)
      item.flag = false
    },
    onRemoveGroup(group, index) {
      group.items.forEach(i => (i.flag = false))
      this.groupList.splice(index, 1)
    },
    init() {
      let items = this.items.map(item => Object.assign({ flag: false }, item))
      const groups = cloneDeep(this.groups)
      const ids = []
      groups.forEach(g => {
        g.isEdit = false
        if (!g.items) {
          g.items = []
        }
        ids.push(...g.item_ids)
        g.items = g.item_ids.reduce((res, id) => {
          let find = items.find(i => i.id === id)
          if (find) {
            find.flag = true
            res.push(find)
          }
          return res
        }, [])
      })
      this.itemList = items
      this.groupList = groups
    },
    onClose() {
      this.$emit('close')
    },
    onConfirm() {
      this.$emit('confirm', this.groupList)
      // 指标统计-地区维度分组管理不需要关闭弹窗
      if(this.notNeedClose) return
      this.onClose()
    },
    initDrag() {
      if (this.removeDragHandler) {
        this.removeDragHandler()
        this.removeDragHandler = null
      }
      this.$surveyBus.$emit(CHANGE_WINDOW_CLICK_SELECT_QUESTION, false)
      this.removeDragHandler = drag(
        this.$refs.leftItemContainer,
        this.$refs.rightContainer,
        (id, p, g) => {
          let item = this.itemList.find(i => i.id === id)
          if (!item) return
          let group = this.groupList[Number(g?.id)]
          if (!group) return
          this.checkList.push(id)
          this.onJoin(group)
        },
        {
          zIndex: 3000,
          itemClass: 'drag-class-box',
          showLine: false,
          groupClassName: 'drag-class-box'
        }
      )
    }
  },
  beforeDestroy() {
    if (this.removeDragHandler) {
      this.removeDragHandler()
      this.$surveyBus.$emit(CHANGE_WINDOW_CLICK_SELECT_QUESTION, true)
      this.removeDragHandler = null
    }
    if (this.uw) {
      this.uw()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initDrag()
      this.uw = this.$watch('noGroupItems', () => {
        this.$nextTick(() => {
          this.initDrag()
        })
      })
    })
  },
  watch: {}
}
</script>

<style lang="scss">
.answer-group-rich-text {
  box-sizing: border-box;

  img {
    max-width: 100%;
    height: auto;
  }
}

.answer-group-popup {
  user-select: none;

  .light-question {
    @apply border-theme;
  }
}

.answer-group-box {
  @apply border border-dashed border-border-gray;
  height: 110px;
}
</style>
<style lang="scss" scoped>
  ::v-deep .el-dialog__headerbtn .el-dialog__close{
    font-size: 18px !important;
  }
  .el-dialog__wrapper{
    background: rgba(0,0,0,0.5) !important;
  }
</style>
